export const manageErrors = {
  data() {
    return {
      error_response: null,
    };
  },
  computed: {
    errorMessages() {
      if (this.error_response) {
        if (this.error_response.status == 500) {
          return ['Spiacente, qualcosa non ha funzionato. Ricaricare la pagina'];
        } else {
          return this.error_response.data;
        }
      }
    },
  },
};
